import React from "react";
import { Dialog } from "@mui/material";
import { Transition } from "./Transition";
import { X } from "feather-icons-react/build/IconComponents";
import { t } from "i18next";
import { ButtonComponent } from '@shopeasy-dashboard-ui/ui-library';

const ImageConfirmation = ({
  heading,
  subheading,
  image,
  isConfirmationImageOpen,
  closeImageConfirmation,
  runFunction,
}) => {
  return (
    <Dialog
      open={isConfirmationImageOpen}
      TransitionComponent={Transition}
      keepMounted
      onClose={closeImageConfirmation}
      aria-describedby="alert-dialog-slide-description"
    >
      <div className="w-full secondary-bg-color sm:w-[600px] p-6 rounded-[6px]">
        <div className="flex text-primary items-center justify-between">
          <p className="text-lg font-medium">{heading}</p>
          <button
            onClick={(e) => {
              e.preventDefault();
              closeImageConfirmation();
            }}
            className="close-btn"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
        <hr className="my-4 main-border-color"></hr>
        <p className="text-base table-text">{subheading}</p>
        {image && (
          <div className="flex items-center my-3">
            <img src={image} alt="Confirmation" className="max-h-[250px] rounded-lg object-contain mx-auto" />
          </div>
        )}
        <div className="flex items-center gap-2 mt-5">
          <ButtonComponent
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              runFunction();
            }}
          >
            {t("lang_Yes")}
          </ButtonComponent>
          <ButtonComponent
            variant="secondary"
            onClick={(e) => {
              e.preventDefault();
              closeImageConfirmation();
            }}
          >
            {t("lang_cancel")}
          </ButtonComponent>
        </div>
      </div>
    </Dialog>
  );
};

export default ImageConfirmation;
